import React from 'react';

function UpcomingEventsCard({ team, events = [] }) {
  if (events.length === 0) return null;

  return (
    <div className="cdp-card">
      <h2 className="cdp-card-title">Upcoming events ({events.length})</h2>

      <div className="cdp-upcoming-events-list">
        {events.map((event) => (
          <a key={event.id} href={`/teams/${team.id}/confirms/${event.id}`} className="cdp-upcoming-event-row">
            {event.compressed_main_event_image_url && (
              <img
                className="cdp-upcoming-event-art"
                src={event.compressed_main_event_image_url}
                alt=""
              />
            )}
            <div className="cdp-upcoming-event-info">
              <div className="cdp-upcoming-event-title">{event.title}</div>
              <div className="cdp-upcoming-event-meta">
                {[event.human_date_and_time, event.venue_name].filter(Boolean).join(' · ')}
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}

export default UpcomingEventsCard;
